import React from 'react';

export function Kicker({ children, className = '' }) {
  return <div className={`pn-kicker ${className}`}>{children}</div>;
}

export function SectionTitle({ children, kicker, sub, className = '' }) {
  return (
    <div className={`max-w-3xl ${className}`}>
      {kicker && <Kicker>{kicker}</Kicker>}
      <h2 className="mt-3 font-display text-3xl font-semibold tracking-tight text-[#14171C] sm:text-4xl">{children}</h2>
      {sub && <p className="mt-4 text-[15px] leading-relaxed text-[#4A4D52]">{sub}</p>}
    </div>
  );
}
